var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.863,
    height: 59.886,
    viewBox: "0 0 71.863 59.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload_1_",
    "data-name": "upload (1)",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75394",
    "data-name": "Path 75394",
    d: "M6.994,25.954A2.829,2.829,0,0,1,4,22.96,20.831,20.831,0,0,1,24.96,2,21.5,21.5,0,0,1,45.022,16.672a2.842,2.842,0,0,1-2.1,3.593,3.115,3.115,0,0,1-3.893-1.8A14.465,14.465,0,0,0,24.96,7.989,14.826,14.826,0,0,0,9.989,22.96,2.829,2.829,0,0,1,6.994,25.954Z",
    transform: "translate(7.977 0)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75395",
    "data-name": "Path 75395",
    d: "M45.92,41.931a2.994,2.994,0,0,1,0-5.989,11.977,11.977,0,0,0,0-23.954,10.186,10.186,0,0,0-2.994.3,3.079,3.079,0,0,1-3.593-2.1,3.079,3.079,0,0,1,2.1-3.593A23.113,23.113,0,0,1,45.92,6a17.966,17.966,0,0,1,0,35.931Zm-29.943,0H6.994a2.994,2.994,0,0,1,0-5.989h8.983a2.994,2.994,0,0,1,0,5.989Z",
    transform: "translate(7.977 7.977)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75396",
    "data-name": "Path 75396",
    d: "M53.9,37.943H47.909a2.994,2.994,0,1,1,0-5.989H53.9a2.994,2.994,0,0,1,0,5.989Zm-38.926,0A14.826,14.826,0,0,1,0,22.971,14.826,14.826,0,0,1,14.971,8a2.829,2.829,0,0,1,2.994,2.994,2.829,2.829,0,0,1-2.994,2.994,8.823,8.823,0,0,0-8.983,8.983,8.823,8.823,0,0,0,8.983,8.983,2.994,2.994,0,0,1,0,5.989ZM35.931,49.92a2.829,2.829,0,0,1-2.994-2.994V16.983a2.994,2.994,0,1,1,5.989,0V46.926A2.829,2.829,0,0,1,35.931,49.92Z",
    transform: "translate(0 11.966)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75397",
    "data-name": "Path 75397",
    d: "M10.994,24.971a2.718,2.718,0,0,1-2.1-.9,2.894,2.894,0,0,1,0-4.192L17.881,10.9a2.964,2.964,0,0,1,4.192,4.192L13.09,24.073A2.718,2.718,0,0,1,10.994,24.971Z",
    transform: "translate(15.954 15.954)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75398",
    "data-name": "Path 75398",
    d: "M22.977,24.971a2.718,2.718,0,0,1-2.1-.9L11.9,15.09A2.964,2.964,0,0,1,16.09,10.9l8.983,8.983a2.894,2.894,0,0,1,0,4.192A2.718,2.718,0,0,1,22.977,24.971Z",
    transform: "translate(21.937 15.954)",
    fill: "#fe6831"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c62fc6844607e9b6b830a57efe3608cb.svg";
export { ForwardRef as ReactComponent };